// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"xO-z","carouselContainer":"yO-z"};